
  
export default {
  namespace: 'unfinishedTransactions',
  state: {
    basicInfo: {},
  },
  effects: {
    * basicInfo ({ payload }, { call, put }) {
    
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
